<template>
  <ModalPlay size="xs" :icon="danger ? 'warning' : undefined" :icon-color="danger ? 'var(--feedback-error-500)' : undefined" :title="title" :hide-header="!danger" @close="$emit('close')">
    <div class="tw:flex tw:flex-col tw:gap-4">
      <TextPlay v-if="!danger" size="xl" weight="bold" :text="title" />
      <TextPlay size="base" :text="description" />
    </div>

    <template #footer>
      <ButtonPlayV2 variant="ghost" text="Não" @click="$emit('close')" />
      <ButtonPlayV2 variant="filled" :color="color" text="Sim" @click="handleConfirm" />
    </template>
  </ModalPlay>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { ModalPlay } from '@/components/atomic';

const emit = defineEmits(['close']);

const props = defineProps<{
  title: string;
  description: string;
  onConfirm: () => void;
  danger?: boolean;
}>();

const color = computed(() => {
  return props.danger ? 'var(--feedback-error-500)' : 'var(--maincolor)';
});

function handleConfirm() {
  emit('close');
  props.onConfirm();
}
</script>
